<!--
    Summary:
        hkml.exhibition.web - p3-paternity-test3
    ChangeLog:
        wangn on 2020/11/28 added
-->
<template>
    <div class="v-p3-paternity-test3" title="p3-paternity-test3">
      <div class="header">
        <div class="title">{{$t('PaternityTest.p3_title')}}</div>
        <div class="subtitle">{{$t('PaternityTest.p3_subtitle')}}</div>
      </div>
      <p class="p m">
        {{$t('PaternityTest.p3_1')}}
      </p>
      <p class="p">
        <span class="p-title">{{$t('PaternityTest.p3_2')}}</span>
        {{$t('PaternityTest.p3_2_1')}}
      </p>
      <p class="p">
        <span class="p-title">{{$t('PaternityTest.p3_3')}}</span>
        {{$t('PaternityTest.p3_3_1')}}
      </p>
    </div>
</template>

<script>
    export default {
        name: "p3-paternity-test3"
    }
</script>
<style scoped lang="scss">
  .en .v-paternity-test .v-p3-paternity-test3{
    .header{
      top: 5.8vw;
      left: 13vw;
      .title{
        font-size: 2vw;
        line-height: 3.13vw;
      }
      .subtitle{
        font-size: 1.66vw;
      }
    }
  }
</style>
<style scoped lang="scss">
    .v-p3-paternity-test3 {
      position: relative;
      text-align: left;

      background: url("../../../assets/images/projects/paternity-test/p3.jpg");
      background-size: 100% 100%;
      padding: 0 8vw 0 35vw;
      height: 34.9vw;

      display: flex;
      justify-content: center;
      flex-direction: column;
      .header{
        position: absolute;
        top: 5.5vw;
        left: 14vw;
        color: #ffffff;
        font-weight: bold;
        text-align: center;
        .title{
          font-size: 4.17vw;
          line-height: 3.13vw;
        }
        .subtitle{
          font-size: 2.66vw;
        }
      }

      .p{
        // margin-bottom: 1vw;
        // &:first-child{
        //  margin-bottom: 0vw;
        // }
        &.m{
          // margin-bottom: 2vw;
        }
        .p-title{
          /*text-decoration: underline; */
          border-bottom: 1px solid #000;
        }
      }
    }
</style>




// WEBPACK FOOTER //
// src/view/projects/paternity-test/p3-paternity-test3.vue